// TOAST MESSAGES
import * as bootstrap from 'bootstrap';

export function initializeToasts() {
  console.log(bootstrap.Tooltip.VERSION);
  var toastElList = [].slice.call(document.querySelectorAll('.toast'));
  var toastList = toastElList.map(function (toastEl) {
    // Set autohide to true and delay to 3000 milliseconds (3 seconds)
    return new bootstrap.Toast(toastEl, { autohide: true, delay: 3000 });
  });
  toastList.forEach((toast) => toast.show()); // Call the show method to display the toasts
}
